/* ============================================================================
   cl-cards.js — de fotoscroller in de productkaart (Cecile Lavelle)

   De scroller werkt zonder dit bestand: het spoor is een gewone
   scroll-container met snap-punten en elke dia is zelf een link, dus vegen en
   aantikken doen het ook als dit script niet laadt. Wat hier gebeurt is
   alleen verfraaiing — het bijwerken van de puntjes en de pijlen.

   Eén luisteraar op het document in plaats van één per kaart, omdat de
   collectiepagina kaarten bijlaadt (oneindig scrollen en filters vervangen
   het raster). Zo hoeft er na een herlaadbeurt niets opnieuw gekoppeld te
   worden.
   ============================================================================ */
(function () {
  'use strict';

  /* ---- foto's van dia 2 en verder ophalen ---------------------------------
     `loading="lazy"` kijkt naar de verticale positie van een beeld en niet naar
     de horizontale. Dia 2 t/m 5 staan naast dia 1 binnen het kader, dus de
     browser vond ze "in beeld" en haalde ze allemaal meteen op — terwijl je er
     één ziet. Daarom staan hun src en srcset in data-attributen (zie
     snippets/product-item.liquid) en zetten we ze hier terug.

     Twee momenten, in deze volgorde:
       1. zodra iemand de kaart aanraakt of eroverheen gaat — dan is het nodig;
       2. anders vanzelf zodra de pagina klaar is en de browser niets omhanden
          heeft, voor alles wat dan in of vlak bij beeld staat.
     Zo verdwijnt het van het kritieke pad zonder dat er ooit een lege dia in
     beeld kan komen. Zonder JS staat er een <noscript>-foto in elke dia. */
  function hydrateer(spoor) {
    if (!spoor || spoor.clGevuld) return;
    spoor.clGevuld = true;
    var beelden = spoor.querySelectorAll('img[data-cl-src]');
    for (var i = 0; i < beelden.length; i++) {
      var img = beelden[i];
      var set = img.getAttribute('data-cl-srcset');
      if (set) { img.setAttribute('srcset', set); img.removeAttribute('data-cl-srcset'); }
      img.setAttribute('src', img.getAttribute('data-cl-src'));
      img.removeAttribute('data-cl-src');
    }
  }

  function spoorVan(doel) {
    if (!doel || !doel.closest) return null;
    var beeld = doel.closest('.cl-kaart__beeld');
    return beeld ? beeld.querySelector('[data-cl-spoor]') : null;
  }

  // 1. aanraken, zweven of vegen — het vroegste signaal dat er gekeken wordt.
  ['pointerdown', 'touchstart', 'mouseover'].forEach(function (naam) {
    document.addEventListener(naam, function (e) { hydrateer(spoorVan(e.target)); }, { capture: true, passive: true });
  });

  /* 2. toetsenbord: de dia's zelf zijn aria-hidden, maar de kaart kan focus
        krijgen en dan hoort de foto er te staan. */
  document.addEventListener('focusin', function (e) { hydrateer(spoorVan(e.target)); }, true);

  /* Bewust géén vangnet dat na het laden alsnog alles ophaalt. Dat hoeft niet:
     elke dia begint met de vervaagde vulling die er toch al stond, dus er kan
     nooit een lege dia in beeld komen — ook niet zonder JS. Wie nooit veegt,
     haalt de foto's nooit op. Dat is precies de bedoeling. */

  function huidigeDia(spoor) {
    if (!spoor.clientWidth) return 0;
    return Math.round(spoor.scrollLeft / spoor.clientWidth);
  }

  function ververs(spoor) {
    var beeld = spoor.parentElement;
    if (!beeld) return;

    // Het segment van de haarlijn is 1/aantal breed; verschuiven met een
    // veelvoud van zijn eigen breedte zet hem op de juiste foto.
    beeld.style.setProperty('--cl-index', String(huidigeDia(spoor)));
  }

  // Scroll-events bubbelen niet, dus in de capture-fase meeluisteren.
  document.addEventListener(
    'scroll',
    function (e) {
      var doel = e.target;
      if (doel && doel.nodeType === 1 && doel.hasAttribute && doel.hasAttribute('data-cl-spoor')) {
        hydrateer(doel);
        ververs(doel);
      }
    },
    true
  );

  /* ---- muisbediening op desktop ------------------------------------------
     Met een muis zijn er geen puntjes en geen pijlen te zien: de foto volgt de
     horizontale positie van de cursor. De foto wordt in evenveel stroken
     verdeeld als er dia's zijn, dus links staan is foto 1 en rechts is de
     laatste. Dat is chroomloos en het is wat je in deze branche gewend bent.

     Alleen bij een echte muis. Op touch bestaat 'zweven' niet en zou dit bij
     de eerste aanraking de foto laten verspringen. */
  var muis = window.matchMedia('(pointer: fine)');

  document.addEventListener(
    'mousemove',
    function (e) {
      if (!muis.matches || !e.target.closest) return;

      var beeld = e.target.closest('.cl-kaart__beeld');
      if (!beeld) return;

      var spoor = beeld.querySelector('[data-cl-spoor]');
      if (!spoor || spoor.children.length < 2 || !spoor.clientWidth) return;

      var vak = beeld.getBoundingClientRect();
      var aantal = spoor.children.length;
      var deel = (e.clientX - vak.left) / vak.width;
      var index = Math.floor(deel * aantal);
      if (index < 0) index = 0;
      if (index > aantal - 1) index = aantal - 1;

      // Alleen schrijven als er echt iets verandert; mousemove vuurt vaak.
      if (index !== huidigeDia(spoor)) {
        spoor.scrollLeft = index * spoor.clientWidth;
      }
    },
    true
  );

  // Terug naar de hoofdfoto zodra de muis de kaart verlaat, anders blijft het
  // raster achter in een willekeurige stand. mouseleave bubbelt niet, dus ook
  // hier de capture-fase.
  document.addEventListener(
    'mouseleave',
    function (e) {
      if (!muis.matches || !e.target.classList) return;
      if (!e.target.classList.contains('cl-kaart__beeld')) return;

      var spoor = e.target.querySelector('[data-cl-spoor]');
      if (spoor) spoor.scrollLeft = 0;
    },
    true
  );
})();
